var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"q_checkbox"},[_c('div',{class:[{ disabled: _vm.disabled }, 'checkBox'],style:({ width: _vm.size, height: _vm.size }),on:{"click":_vm.checkedClick}},[(_vm.checked)?_c('el-image',{attrs:{"src":require('@/assets/images/checked.png')}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }